import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7 1a1 1 0 0 0-2 0v3a1 1 0 0 0 2 0zM1 8a1 1 0 0 1 1-1h17a5 5 0 1 1 0 10 5 5 0 0 1-5 5H6a5 5 0 0 1-5-5zm18 7V9a3 3 0 0 1 0 6m-2-6v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V9zm-7-9a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0V1a1 1 0 0 1 1-1m5 1a1 1 0 1 0-2 0v3a1 1 0 1 0 2 0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }